export enum ScheduleRoleContent {
    PERMISSION_SCHED_ADD_COPY = 'BD_SCHED_ACD',
    PERMISSION_SCHED_VIEW = 'OTHER_ALL_MSCHED'
}

export enum ScheduleRoleKey {
    M2_ROLE = 'm2',
    M3_ROLE = 'm3'
}

export enum NoteOperation {
    UPDATE = 'UPDATE',
    INSERT = 'INSERT'
}

export enum ScheduleFilterScreen {
    SCHEDULE = 'SCHEDULE',
    MOBILESETTING = 'MOBILESETTING'
}